import * as Yup from "yup";
import { CourseInput } from "./../../../__generated__/gql-types/globalTypes";

export const initialValuesObj: CourseInput = {
  lessons: [],
  title: "",
  description: "",
  themes: null,
  axes: null,
  tags: null,
  grade_id: 3,
  type: "",
  nem: true,
  program_2017: false,
  program_2526: false,
  english: false,
  english_2526: false,
  english_2526_spark: false,
  math_fibonacci: false,
  math_descartes: false,
  reading: false,
  hide_course_for_students: false,
  subject_id: 1,
  threemester: null,
  threemester_2017: null,
  threemester_2526: null,
  threemester_english: null,
  threemester_english_2526: null,
  threemester_english_2526_spark: null,
  threemester_math_fibonacci: null,
  threemester_math_descartes: null,
  threemester_reading: null,
  month: null,
  sep_book_pages: "",
  sep_book_pages_2017: "",
  sep_book_pages_2526: "",
  sep_book_pages_english: "",
  sep_book_pages_english_2526: "",
  sep_book_pages_english_2526_spark: "",
  sep_book_pages_reading: "",
  week: null,
  week_2017: null,
  week_2526: null,
  week_english: null,
  week_english_2526: null,
  week_english_2526_spark: null,
  week_math_fibonacci: null,
  week_math_descartes: null,
  week_reading: null,
  lessons_2425: [],
  lessons_2526: [],
};

export const NewUsersSchema = Yup.object().shape({
  title: Yup.string().required("El titulo requerido."),
  description: Yup.string().required("La descripcion requerido."),
  type: Yup.string().required("El tipo es requerido."),
});
